import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SettingsService} from "../../services/settings/settings.service";
import {UserService} from "../../services/user/user.service";
import {UserProfileService} from '../../services/user/user-profile.service';
import {InternationalizationService} from "../../services/internationalization/internationalization.service";
import {Subscription} from "rxjs";
import {$translate} from "../../services/internationalization/localize.service";
import {ImpersonateDialogComponent} from '../impersonate-dialog/impersonate-dialog.component';

@Component({
  selector: 'sb-user-profile-menu-list',
  templateUrl: './user-profile-menu-list.component.html',
  styleUrls: ['./user-profile-menu-list.component.scss']
})
export class UserProfileMenuListComponent implements OnInit, OnDestroy {

  canViewUserSettings = true;
  canViewResetPassword = true;
  canViewLanguageSelector = false;

  firstName = "User";
  userGreeting = "Hi, User";

  storedHomePage: string;

  hasStoredHomePage = false;

  canImpersonate = false;
  isImpersonated = false;

  // I18n Labels
  buttonLabel: string;
  userSettingsLabel: string;
  setHomePageLabel: string;
  clearHomePageLabel: string;
  resetPasswordLabel: string;
  logoutLabel: string;
  canImpersonateLabel: string;
  clearImpersonateLabel: string;

  showImpersonateDialog: boolean = false;

  private localeChanged$: Subscription;

  public userInitials: string = this.userService.getInitials();
  // public userPhoto: string = this.userService.getPhoto(); // might return an id: /attachment/:id

  @ViewChild(ImpersonateDialogComponent, { static: false })
  impersonateDialogComponent: ImpersonateDialogComponent;

  constructor(private settingsService: SettingsService,
              private i18nService: InternationalizationService,
              private userService: UserService,
              private userProfileService: UserProfileService) {

    this.userProfileService.getUserProfile(false).then((profile) => {
      this.canImpersonate = profile["isImpersonated"] != null;
      this.isImpersonated = profile["isImpersonated"] === true;
    });

  }

  async ngOnInit() {
    this.canViewUserSettings = this.settingsService.settings.canViewUserSettings;
    this.canViewResetPassword = this.userService.getBooleanProperty("system.password.reset.enabled", true) && this.userService.getProperty("system.password.reset.locations", "menu").includes("menu");
    this.canViewLanguageSelector = this.userService.isMultilingual();

    this.firstName = this.userService.getFirstName();
    this.userGreeting = this.i18nService.getMessage('menu.user.welcome', {0: this.firstName});
    this.buttonLabel = `<span class="user-avatar user-self">${this.userInitials}</span> ${this.firstName}`;
    // this.buttonLabel = this.firstName;

    this.storedHomePage = this.userService.getUserProfileProperty("user.home.page", "");

    this.hasStoredHomePage = this.storedHomePage.length > 0;

    this.localeChanged$ = this.i18nService.localeChanged$.subscribe((locale: string) => {
      this.updateMessages();
    });

    this.updateMessages();
  }

  ngOnDestroy() {
    this.localeChanged$ && this.localeChanged$.unsubscribe();
  }

  setHomePage() {
    const hash = window.location.hash;
    if (hash) {
      this.storedHomePage = hash;
      this.hasStoredHomePage = true;
      this.userService.updateUserProfileSetting("user.home.page", hash);
    }
  }

  clearHomePage() {
    this.storedHomePage = "";
    this.hasStoredHomePage = false;
    this.userService.deleteUserProfileSetting("user.home.page");
  }

  impersonate() {
    this.impersonateDialogComponent.showDialog();
  }

  private updateMessages() {
    this.userSettingsLabel = $translate("ng.component.user-profile-menu-list.user-settings")`User settings`;
    this.setHomePageLabel = $translate("ng.component.user-profile-menu-list.set-home-page")`Make this my home page`;
    this.clearHomePageLabel = $translate("ng.component.user-profile-menu-list.clear-home-page")`Reset home page`;
    this.resetPasswordLabel = $translate("ng.component.user-profile-menu-list.reset-password")`Reset password`;
    this.logoutLabel = $translate("ng.component.user-profile-menu-list.logout")`Log out`;
    this.canImpersonateLabel = $translate("system.impersonation.menu_item_impersonate")`Impersonate`;
    this.clearImpersonateLabel = $translate("system.impersonation.menu_item_clear")`Clear impersonation`;
  }

  unImpersonate() {
    this.userService.unImpersonate();
  }
}
